"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGeneratedDescriptionDto = instanceOfGeneratedDescriptionDto;
exports.GeneratedDescriptionDtoFromJSON = GeneratedDescriptionDtoFromJSON;
exports.GeneratedDescriptionDtoFromJSONTyped = GeneratedDescriptionDtoFromJSONTyped;
exports.GeneratedDescriptionDtoToJSON = GeneratedDescriptionDtoToJSON;
exports.GeneratedDescriptionDtoToJSONTyped = GeneratedDescriptionDtoToJSONTyped;
/**
 * Check if a given object implements the GeneratedDescriptionDto interface.
 */
function instanceOfGeneratedDescriptionDto(value) {
    if (!('description' in value) || value['description'] === undefined)
        return false;
    return true;
}
function GeneratedDescriptionDtoFromJSON(json) {
    return GeneratedDescriptionDtoFromJSONTyped(json, false);
}
function GeneratedDescriptionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'description': json['description'],
    };
}
function GeneratedDescriptionDtoToJSON(json) {
    return GeneratedDescriptionDtoToJSONTyped(json, false);
}
function GeneratedDescriptionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'description': value['description'],
    };
}
//# sourceMappingURL=GeneratedDescriptionDto.js.map